// extracted by css-extract-rspack-plugin
export default {"wrapper":"_f1982050"};